import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';

import {
    SituationWrapper,
    InningWrapper
} from './Summary.style';
import Score from './Score';

const DetailSituation = ({
    inning,
    halfInning = '',
    awayScore,
    homeScore,
    away,
    home,
    isTopInning,
    isScoringPlay,
    isMobile
}) => {
    const inningOrdinal = useTranslator('ranking_' + inning, inning);
    const replacement = { inning, inningOrdinal };
    const translationKey = halfInning === 'top' ? 'inning_state_top_abbrev' : 'inning_state_bottom_abbrev';
    const inningHalfText = useTranslator(translationKey, halfInning === 'top' ? 'Top' : 'Bot');
    const showInning = inning && halfInning;
    const title = useTranslator(translationKey, `${inningHalfText} ${inningOrdinal}`, replacement);

    return (
        <SituationWrapper $isMobile={isMobile}>
            {showInning && <InningWrapper>{title}</InningWrapper>}
            <span> | </span>
            <Score
                awayScore={awayScore}
                homeScore={homeScore}
                away={away}
                home={home}
                isTopInning={isTopInning}
                isScoringPlay={isScoringPlay}
            />
        </SituationWrapper>
    );
};

DetailSituation.propTypes = {
    inning: PropTypes.number,
    halfInning: PropTypes.string,
    awayScore: PropTypes.number,
    homeScore: PropTypes.number,
    away: PropTypes.object,
    home: PropTypes.object,
    isTopInning: PropTypes.bool,
    isScoringPlay: PropTypes.bool,
    isMobile: PropTypes.bool
};

export default DetailSituation;
